/* eslint-disable */
import React from 'react';
import { withTranslation } from 'react-i18next';
import DropdownComp from '../../../../components/dropdown/dropdown';
import KRService from '../../../services/kr.service';
import { WbEventHandlerMixins } from '../../../../utils/common';
import ErrorDisplay from '../../../../components/common/errorDisplay.component';
import AlignmentSlider from '../../../../components/okr/alignmentSlider';
import { OkrPopUp } from '../../../types/okrpopup.types';
import KrDataSourceIcon, { getDataSourceInfo } from '../../../../components/krDataSourceIcon';
import { treeGridHelper } from '../../../../utils/alignment-treegrid';
import { KeyDownEvent } from '../../../../utils/eventKey';
import * as OkrPopIpActions from '../../../actions/okr_popup.action'
import GoalServices from '../../../../services/goal.services';
import { SubmitEvent } from '@workboard/ui-list-filters';
import AlignmentModalFilters from './alignmentModalFilters.component';
import {
    getDefaultCriteria, getActiveFilterCount, filterAlignmentTree, getTeamOptions,
    reconcileTeamCriteria, AlignmentFilterCriterion, TeamOption,
} from './alignmentModalFilters.helpers';
import { getFilterStorageKey, loadFilterCriteria, saveFilterCriteria } from './alignmentFilterStorage';

const krService = new KRService();
interface OkrAlignProps extends OkrPopUp {
    showHeader: boolean
    key: string
    wrapperClass: string
    filterValue: string
    showTitle: boolean
    t: any
}

type OkrAlingState = {
    originalData: string[]
    goals: any
    filterValue: string
    indentGoals: any[]
    showSlideshow: boolean
    currentSlideDataIndex: number
    showRealOwner: boolean
    isPagination: boolean
    filterCriteria: AlignmentFilterCriterion[]
    filterInitialValues: Partial<SubmitEvent['values']>
    appliedFilterCount: number
    teamOptions: TeamOption[]
}

class OkrAlignment extends React.Component<OkrAlignProps, OkrAlingState> {
    recursiveData: any;

    clickCount: any;

    clickTimer: any;
    GoalServices: any;

    filterStorageKey: string | null;

    filterTreeMemo: { goals?: any; criteria?: any; goalId?: any; result?: any } = {};

    constructor (props) {
        super(props);
        this.recursiveData = [];
        this.clickCount = 0;
        this.clickTimer = null;
        const uData = (window as any).uData || {};
        this.filterStorageKey = getFilterStorageKey(uData.org_id, uData.user_id, props.goalId);
        const initialCriteria = loadFilterCriteria(this.filterStorageKey) || getDefaultCriteria(props.t);
        this.state = {
            originalData: [],
            goals: [],
            filterValue: props.filterValue || '1',
            indentGoals: [],
            showSlideshow: false,
            currentSlideDataIndex: 0,
            showRealOwner: false,
            isPagination: false,
            filterCriteria: initialCriteria,
            filterInitialValues: this.buildFilterInitialValues(initialCriteria),
            appliedFilterCount: getActiveFilterCount(initialCriteria),
            teamOptions: []
        };

        this.getAlignData = this.getAlignData.bind(this);
        this.getMaxExpandLevel = this.getMaxExpandLevel.bind(this);
        this.resetRecursiveData = this.resetRecursiveData.bind(this);
        this.viewOkrClick = this.viewOkrClick.bind(this);
        this.topViewClick = this.topViewClick.bind(this);
        this.setContainerHeight = this.setContainerHeight.bind(this);
        this.onChangeFilters = this.onChangeFilters.bind(this);
        this.viewMetricDetails = this.viewMetricDetails.bind(this);
        this.collapseClick = this.collapseClick.bind(this);
        this.showMetrics = this.showMetrics.bind(this);
        this.GoalServices = new GoalServices();
    }

    componentDidMount () {
        this.getAlignData();
    }

    async getAlignData () {
        const _this = this;
        const { goalId } = this.props;
        const params: any = {};
        params.goalId = goalId;
        params.topViewClick = true;
        params.okrDetailsPage = true;
        const contentId = document.getElementById('content');
        showLoaderWidget(contentId);
        await krService.goalAlignmentSearch(params)
            .then((response) => {
                if (response.data.status == 'success') {
                    const recursiveGoals = _this.getRecursiveData(response.data.goals);
                    const teamOptions = getTeamOptions(response.data.goals);
                    const filterCriteria = reconcileTeamCriteria(_this.state.filterCriteria, teamOptions);
                    _this.setState({
                        goals: recursiveGoals,
                        isPagination: response.data.isPagination,
                        showRealOwner: response.data.show_real_owner,
                        originalData: response.data.goals,
                        teamOptions,
                        filterCriteria,
                        filterInitialValues: _this.buildFilterInitialValues(filterCriteria),
                        appliedFilterCount: getActiveFilterCount(filterCriteria),
                    })
                }
                removeLoader();
            })
            .catch((err: any) => {
                console.log('err', err);
                removeLoader();
            });
    }

    getMaxExpandLevel (goals = []) {
        const g = goals.filter(goal => goal.collapse).map(g1 => g1.parentRow);
        const maxLevel = g.length ? Math.max(...g) + 1 : 0;
        return maxLevel > 0 ? maxLevel : 0;
    }

    getRecursiveData (goals = [], i = 0, refId = 0, withOutFilter = false) {
        this.resetRecursiveData();
        this.recursiveGoals(goals, i, refId, withOutFilter);
        return this.recursiveData;
    }

    setContainerHeight () {
        setTimeout(() => {
            if ($('.goalAlignRender').length && $('.fullalignment-report-wrapper').length) {
                const height = $('.fullalignment-report-wrapper').height();
                $('.goalAlignRender').append(
                    `<style> #content {height:${height + 60}px }</style>`,
                );
            }
        }, 100);
    }

    componentDidUpdate (prevProps, prevState) {
        if ((this.state.filterValue != prevProps.filterValue)
            || (typeof this.state.isPagination !== 'undefined' && typeof prevProps.isPagination !== 'undefined' && this.state.isPagination != prevProps.isPagination)) {
            const stateObj: any = { currentSlideDataIndex: 0, filterValue: this.props.filterValue };
            this.setState(stateObj, () => {
                const recursiveGoals = this.getRecursiveData(this.state.goals || []);
                this.setState({ goals: recursiveGoals, originalData: this.state.goals, indentGoals: [] });
            });
        }
    }

    recursiveGoals (goals = [], i = 0, refId = 0, withOutFilter = false, showLevel = false) {
        const filterValue = typeof this.state !== 'undefined'
            && typeof this.state.filterValue !== 'undefined'
            ? this.state.filterValue
            : (typeof this.props.filterValue !== 'undefined' ? this.props.filterValue : '1');
        if (Array.isArray(goals) && goals.length) {
            const goalsLength = goals.length;
            goals.map((g, ind) => {
                const _id: any = `${refId}_${ind}_${g.id}`;
                let collapse = false;
                let showMetrics = false;
                let showTable = false;
                if (!withOutFilter) {
                    showTable = i < 1;
                    if (filterValue == '1') {
                        if (i < 2) {
                            collapse = i < 1;
                            showTable = true;
                        }
                    } else if (filterValue == '2' || filterValue == '3') {
                        collapse = true;
                        showTable = true;
                        showMetrics = filterValue == '3';
                    } else if (filterValue == '5') { // goalsalign one level up and down in goal details page.
                        collapse = !!((goalsLength - 1 == ind && i == 0));
                        if ((i == 1 || i == 2) && showLevel) {
                            collapse = (g.id == this.props.goalId);
                            showTable = true;
                        }
                    }
                    collapse = !!(collapse && g.goalsCount > 0);
                } else {
                    showTable = i < 1;
                }
                g = Object.assign(g, {
                    parentRow: i,
                    rowId: ind,
                    parentRefId: _id,
                    collapse,
                    showMetrics,
                    showTable,
                });
                this.recursiveData = this.recursiveData.concat(g);
                if (
                    typeof g.goals !== 'undefined'
                    && Array.isArray(g.goals)
                    && g.goals.length
                ) {
                    const _showLevel = !!(((goalsLength - 1 == ind && i == 0) || (i == 1 && showLevel && collapse)));
                    return this.recursiveGoals(g.goals, i + 1, _id, withOutFilter, _showLevel);
                }
            });
        }
    }

    topViewClick (e, goal) {
        e.preventDefault();
        const _this = this;
        showLoaderWidget($('#content'));
        const regExp = new RegExp(`^${goal.parentRefId}`);
        const params: any = {};
        params.goalId = goal.id;
        params.topViewClick = true;
        const response: any = {};
        // response = krService.getGoalAlignmentSearch(params);
        krService.getGoalAlignmentSearch({
            goalId: goal.id,
            topViewClick: true,
        }).then((response) => {
            if (response.data) {
                removeLoaderWidget();
                const topViewGoals = response.data.goals || [];
                const topViewGoalsLength = topViewGoals.length;
                const indentGoals = [];
                if (topViewGoalsLength) {
                    const positionId = goal.parentRefId.split('_')[1];
                    let recursiveGoals: any = {};
                    recursiveGoals = _this.getRecursiveData(topViewGoals, 0, 0, true);
                    if (recursiveGoals) {
                        // rebuild parent ref id;
                        let regExp1: any = '';
                        let currentParentRefId = '';
                        recursiveGoals = recursiveGoals.map((g) => {
                            const postions = g.parentRefId.split('_');
                            postions[1] += positionId;
                            g.parentRefId = postions.join('_');
                            if (g.parentRow == 0) {
                                indentGoals.push(g.parentRefId);
                            }
                            if (g.parentRow == 0 && topViewGoalsLength - 1 == g.rowId) {
                                g.collapse = g.goalsCount > 0;
                                regExp1 = new RegExp(`^${g.parentRefId}`);
                            } else if (regExp1 && regExp1.test(g.parentRefId)) {
                                if (g.parentRow == 1) {
                                    g.showTable = true;
                                    if (g.id == goal.id && g.goalsCount > 0) {
                                        g.collapse = true;
                                        currentParentRefId = g.parentRefId;
                                    }
                                } else if (g.parentRow == 2 && currentParentRefId) {
                                    const pid = `${currentParentRefId}_${g.rowId}_${g.id}`;
                                    if (g.parentRefId == pid) {
                                        g.showTable = true;
                                    }
                                }
                            }
                            return g;
                        });
                    }
                    let { goals } = _this.state;
                    const findIndex1 = goals.findIndex(
                        g => g.parentRefId == goal.parentRefId,
                    );
                    goals = goals.filter(g => !regExp.test(g.parentRefId));
                    let state1 = goals.splice(0, findIndex1);
                    state1.splice(findIndex1, 1, ...recursiveGoals);
                    if (goals) {
                        goals = goals.map((g) => {
                            const postions = g.parentRefId.split('_');
                            postions[1] += topViewGoalsLength;
                            g.parentRefId = postions.join('_');
                            return g;
                        });
                    }
                    state1 = state1.concat(...goals);
                    const teamOptions = getTeamOptions(state1);
                    const filterCriteria = reconcileTeamCriteria(_this.state.filterCriteria, teamOptions);
                    _this.setState({
                        goals: state1,
                        indentGoals,
                        teamOptions,
                        filterCriteria,
                        filterInitialValues: _this.buildFilterInitialValues(filterCriteria),
                        appliedFilterCount: getActiveFilterCount(filterCriteria),
                    }, () => {
                        _this.setContainerHeight();
                    });
                }
            }
            // Ally - Send focus to Aligns tab
            const focusEl = document.getElementById('okrActiveTab-Aligns');
            if (focusEl) focusEl.focus();
        });
    }

    onChangeFilters (e, item) {
        let showSlideshow = false;
        let filterValue = item.value;
        const originalFilterValue = item.value;
        const goals = this.state.goals.map((g) => {
            let collapse = false;
            let showMetrics = false;
            let showTable = g.parentRow < 1;
            if (filterValue == '1') {
                if (g.parentRow < 2) {
                    collapse = g.parentRow < 1;
                    showTable = true;
                }
            } else if (filterValue == '2' || filterValue == '3') {
                collapse = true;
                showTable = true;
                showMetrics = !!(filterValue == '3' && g.metricsCount > 0);
            }
            return Object.assign(g, { collapse, showMetrics, showTable });
        });
        $('body').css({ overflow: 'visible' });
        // trapping one-level alignment value to preserve existing state behind the slideshow
        if (filterValue === '6') {
            $('body').css({ overflow: 'hidden' });
            // set it to the current/previous filterValue present in state
            filterValue = this.state.filterValue;
            // then set showSlideshow value
            showSlideshow = true;
            //   wb_track('open_one_level_alignment', { email: 'no data' }); cmt
            //   oneLevelAlignmentEventTracker('ONE_LEVEL_ALIGNMENT_VIEWED','FULL_ALIGNMENT'); cmt
        } else {
            const eventParams: any = {};
            eventParams.eventType = 'ALIGNMENT_FULL_REPORT_VIEWED';
            if (filterValue == '1') {
                eventParams.eventView = 'DEFAULT';
            } else if (filterValue == '2') {
                eventParams.eventView = 'ALL_OKRS';
            } else if (filterValue == '3') {
                eventParams.eventView = 'ALL_OKRS_AND_KRS';
            } else if (filterValue == '4') {
                eventParams.eventView = 'TOP_OKRS';
            }
            //   this.GoalServices.triggerTrackEvent(eventParams); cmt
        }
        this.setState({ filterValue, goals, showSlideshow }, () => {
            removeLoaderWidget();
            this.setContainerHeight();
        });
    }

    getFilterOptions () {
        const { t } = this.props;
        return [
            {
                name: t('Default view'),
                value: '1',
            },
            {
                name: `${t('All Objectives')}`,
                value: '2',
            },
            {
                name: `${t('All Objectives KRs')}`,
                value: '3',
            },
            {
                name: `${t('Top OKRs')}`,
                value: '4',
            },
            {
                name: t('Next-level alignment'),
                value: '6',
            },
        ];
    }

    // Stable identity so react-final-form only reinitializes on Apply/Reset.
    buildFilterInitialValues (criteria: AlignmentFilterCriterion[]): Partial<SubmitEvent['values']> {
        return { group: { operator: 'AND', criteria } } as Partial<SubmitEvent['values']>;
    }

    handleFiltersApply = (event: SubmitEvent) => {
        const criteria = (event?.values?.group?.criteria ?? []) as AlignmentFilterCriterion[];
        this.setState({
            filterCriteria: criteria,
            filterInitialValues: this.buildFilterInitialValues(criteria),
            appliedFilterCount: getActiveFilterCount(criteria),
        });
        saveFilterCriteria(this.filterStorageKey, criteria);
    }

    handleFiltersReset = () => {
        const defaultCriteria = getDefaultCriteria(this.props.t);
        this.setState({
            filterCriteria: defaultCriteria,
            filterInitialValues: this.buildFilterInitialValues(defaultCriteria),
            appliedFilterCount: getActiveFilterCount(defaultCriteria),
        });
        saveFilterCriteria(this.filterStorageKey, defaultCriteria);
    }

    viewOkrClick (e, goal) {
        const { goalId, dispatch } = this.props;
        e.preventDefault();
        if (goalId === goal.id) dispatch(OkrPopIpActions.UpdateModal(false));
        return viewGoalDetailsPage(undefined, { id: goal.id });
    }

    resetRecursiveData () {
        this.recursiveData = [];
    }

    renderLeftTable (g, maxLevel = 0, indentGoals = [], rowIndex = false, gLength = 0, index) {
        const parentRow = g.parentRow || 0;
        const tableStyle: any = {};
        const gridStyle: any = {};
        let padLeft = 0;
        if (parentRow > 0) {
            padLeft = (parentRow - 1) * 40;
            if (!indentGoals.length) {
                padLeft += 23;
            }
        }
        const indentStyle: any = {};
        if (Array.isArray(indentGoals) && indentGoals.length) {
            let isIndentGoals = false;
            for (const id of indentGoals) {
                const regExp = new RegExp(`^${id}`);
                if (regExp.test(g.parentRefId)) {
                    isIndentGoals = true;
                    break;
                }
            }
            indentStyle.paddingLeft = (!isIndentGoals) ? `${(parseInt(g.parentRow) + 1) * 23}px` : ((g.parentRow > 0) ? '23px' : '0px');
        }
        tableStyle.paddingLeft = `${padLeft}px`;
        const isShowMetrics = g.showMetrics || false;
        gridStyle.gridTemplateColumns = `${padLeft || 23}px ${parentRow > 0 ? 40 : 0}px 30px 1fr`;
        const innerGridStyle: any = {};
        const objGridItemWidth: number = (this.props.goalId == g.id ? 71 : 60) + 280;
        innerGridStyle.gridTemplateColumns = `${this.props.goalId == g.id ? 71 : 60}px calc(100% - ${objGridItemWidth}px) 150px 80px 50px`;
        innerGridStyle.borderBottom = '1px solid rgba(204,204,204,.2)';
        const emptyMetricTableWidth = (padLeft || 23) + (parentRow > 0 ? 40 : 0) + 30;

        return (
            <React.Fragment key={`okr_table_left_${g.parentRefId}`}>
                <div
                    aria-expanded={!!g.collapse}
                    aria-level={g.parentRow + 1}
                    aria-posinset={index}
                    aria-setsize={gLength}
                    data-rowtype="obj-rows"
                    onKeyDown={(e) => treeGridHelper('objective-dialog-alignment',
                        () => this.collapseClick(e, g),
                        e, g.goals.length, g.collapse)}
                    role="row"
                    tabIndex={rowIndex ? 0 : -1}
                >
                    <div
                        className="okr-align-table-view okr-align-table-view-grid"
                        style={gridStyle}
                    >
                        {
                            (g.parentRow == 0)
                                ? (
                                    <div>
                                        <div style={{ width: '23px', height: '39px' }} className="okr-align-column-topview">
                                            {g.topView ? (
                                                <div
                                                    aria-label="Top View"
                                                    className="icon icon-outline-arrow_upward-24px cursor-pointer"
                                                    data-coltype="top-view"
                                                    onClick={(e) => this.topViewClick(e, g)}
                                                    onKeyDown={e => KeyDownEvent(e,
                                                        () => this.topViewClick(e, g),
                                                        false, false, true)}
                                                    role="button"
                                                    tabIndex={-1}
                                                />
                                            ) : (
                                                ''
                                            )}
                                        </div>
                                    </div>
                                )
                                : <div>&nbsp;</div>
                        }
                        {
                            parentRow > 0
                                ? <div className="okr-align-table-view">
                                    <div style={{ width: '40px', height: '39px' }}>
                                        <div className="icon icon-alignment_L-24px" />
                                    </div>
                                  </div>
                                : <div>&nbsp;</div>
                        }
                        {g.goals?.length ? (
                            <div style={{ height: '39px' }}>
                                <div
                                    aria-expanded={!!g.collapse}
                                    aria-label="Show Descendant Objectives"
                                    className={`icon ${g.collapse ? 'icon-outline-remove_circle_outline-18px cursor-pointer' : 'icon-outline-add_circle_outline-18px cursor-pointer'
                                    } collaspse-icon`}
                                    data-coltype="show-descendant-obj"
                                    onClick={(e) => this.collapseClick(e, g)}
                                    onKeyDown={e => KeyDownEvent(e,
                                        () => this.collapseClick(e, g),
                                        false, false, true)}
                                    role="button"
                                    tabIndex={-1}
                                />
                            </div>
                        ) : <div>&nbsp;</div>}
                        <div className={`okr-align-table-view-grid ${isShowMetrics ? ' highlighted ' : ''}`} style={innerGridStyle}>
                            <div
                                className="okr-align-table-view"
                                data-coltype="align-col-metric"
                                role="gridcell"
                                tabIndex={-1}
                            >
                                <div
                                    className={`okr-align-column-percentage ${this.props.goalId == g.id ? ' border-left-blue' : ''}`}
                                    style={{
                                        color: g.progressColor, display: 'flex', alignItems: 'center', height: '39px'
                                    }}
                                >
                                    {g.goalPercentage}
                                </div>
                            </div>
                            <div role="gridcell" className={`okr-align-table-view-grid ${isShowMetrics ? ' highlighted ' : ''}`}>
                                <div
                                    aria-expanded={isShowMetrics}
                                    className="okr-align-column-goal cursor-pointer okr-goalname-click"
                                    data-coltype="align-col-goal"
                                    onClick={(e) => this.showMetrics(e, g)}
                                    onKeyDown={e => KeyDownEvent(e,
                                        () => this.showMetrics(e, g),
                                        false, false, true)}
                                    role="button"
                                    tabIndex={-1}
                                    title={g.goal}
                                >
                                    {g.goal}
                                </div>
                            </div>
                            {this.renderRightTable(g)}
                        </div>
                    </div>
                </div>
                {g.showMetrics && g.metrics.length > 0 && this.renderLeftMetricTable(g, emptyMetricTableWidth)}
                {g.goals && g.goals.length > 0 && g.collapse && (
                    g.goals.map((childGoals, gIndex) => this.renderLeftTable(childGoals, 0, [], false, g.goals.length, gIndex + 1))
                )}
            </React.Fragment>
        );
    }

    renderRightTable (g) {
        const isShowMetrics = g.showMetrics || false;
        let dateStr = '';
        const titleAttr: any = {};
        if (g.endDate) {
            dateStr = g.endDate.split(',')[0];
            titleAttr.title = g.endDate;
        }
        const ownerName = `${WbEventHandlerMixins.firstCharUppercase(g.firstname)
        } ${WbEventHandlerMixins.onlyFirstUpperText(g.lastname)}`;
        const title = (g.teamName) ? `${g.ownerName}: ${g.teamName}` : g.ownerName;
        const name = (g.teamName) ? g.teamName : ownerName;
        return (
            <>
                <div className="okr-align-column-ownername" role="gridcell" style={{ width: '150px' }}>
                    <div tabIndex={-1} data-coltype="align-col-owner" className="truncateText showtooltiponoff" title={title} role="tooltip">
                        {name}
                    </div>
                </div>
                <div className="okr-align-column-date" role="gridcell" style={{ width: '80px' }}>
                    <div>
                        <span tabIndex={-1} data-coltype="align-col-date" role="tooltip" {...titleAttr}>{dateStr}</span>
                    </div>
                </div>
                <div className="okr-align-column-viewdetails" role="gridcell" style={{ width: '50px' }}>
                    <div
                        aria-label={`Open Objectives Dialog ${g.goal}`}
                        className="icon icon-outline-open_in_new-18px cursor-pointer"
                        data-coltype="open-objectives"
                        onClick={e => this.viewOkrClick(e, g)}
                        onKeyDown={e => KeyDownEvent(e,
                            () => this.viewOkrClick(e, g),
                            false, false, true)}
                        role="button"
                        tabIndex={-1}
                    />
                </div>
            </>
        );
    }

    leftContentHeader () {
        const { t } = this.props;
        return (
            <div key="left_header">
                <div
                    className="okr-align-table-view-grid"
                    style={{ gridTemplateColumns: '23px calc(100% - 303px) 150px 80px 50px', borderBottom: '1px solid rgba(204,204,204,.2)' }}
                >
                    <div role="cell">&nbsp;</div>
                    <div role="cell">&nbsp;</div>
                    <div role="cell" className="okr-header-title" style={{ paddingLeft: '10px' }}>{t('Owner')}</div>
                    <div role="cell" className="okr-header-title" style={{ paddingLeft: '5px' }}>{t('End Date')}</div>
                    <div role="cell" className="okr-header-title">{t('View')}</div>
                </div>
            </div>
        );
    }

    collapseClick (e, goal) {
        e.preventDefault();
        const collaspe = !goal.collapse;
        const regExp = new RegExp(`^${goal.parentRefId}_`);
        const goals = this.state.goals.map((g) => {
            if (g.parentRefId == goal.parentRefId) {
                g.collapse = !!(collaspe && g.goalsCount > 0);
                g.showMetrics = false;
            } else if (regExp.test(g.parentRefId)) {
                const pid = `${goal.parentRefId}_${g.rowId}_${g.id}`;
                g.collapse = false;
                g.showTable = false;
                if (collaspe && g.parentRefId == pid) {
                    g.showTable = true;
                }
                g.showMetrics = false;
            }
            return g;
        });
        this.setState({ goals });
    }

    viewMetricDetails = (e, metric) => {
        e.stopPropagation();
        // metricDetailsPage(metric.id,null,true);cmt
    }

    renderLeftMetricTable (goal, emptyMetricTableWidth) {
        const { metrics } = goal;
        const { t } = this.props;
        return (
            <div role="treegrid">
                <div role="rowgroup" className="screen-reader-only">
                    <div role="row">
                        <span role="columnheader">{t('Key Result Metric')}</span>
                        <span role="columnheader">{t('Key Result Name')}</span>
                        <span role="columnheader">{t('Data Source')}</span>
                    </div>
                </div>
                <div role="rowgroup">
                    {metrics.map((m, index) => (
                        <div
                            key={index}
                            onKeyDown={(e) => treeGridHelper('objective-dialog-alignment',
                                () => {}, e)}
                            role="row"
                        >
                            <div
                                className="okr-align-table-view-grid"
                                style={{ gridTemplateColumns: `${emptyMetricTableWidth}px calc(100% - ${emptyMetricTableWidth}px)` }}
                            >
                                <div>&nbsp;</div>
                                <div
                                    className="okr-align-table-view-grid"
                                    style={{
                                        gridTemplateColumns: '60px 150px calc(100% - 490px) 280px',
                                        backgroundColor: 'rgba(204,204,204,.1)'
                                    }}
                                >
                                    <div>&nbsp;</div>
                                    <div
                                        className="okr-align-column-met-percentage"
                                        data-coltype="align-col-metric"
                                        role="gridcell"
                                        tabIndex={-1}
                                    >
                                        <div className="okr-align-met-per-text truncateText">
                                            <span
                                                className="okr-met-achieve-text"
                                                style={{ color: m.progressColor || m.progress_color }}
                                            >
                                                {m.achieveTarget || m.achieveTargetText}
                                            </span>
                                            {m.targetDisplay ? (
                                                <span className="okr-met-target-text">
                                                    {' '}
                                                    of
                                                    {' '}
                                                    {m.totalTarget || m.totalTargetText}
                                                </span>
                                            ) : (
                                                ''
                                            )}
                                        </div>
                                    </div>
                                    <div role="gridcell">
                                        <div
                                            className="okr-align-column-met-name"
                                            data-coltype="align-col-goal"
                                            onClick={(e) => this.viewMetricDetails(e, m)}
                                            role="tooltip"
                                            tabIndex={-1}
                                            title={m.name}
                                        >
                                            <div className="white-space-normal">
                                                <span>{m.name}</span>
                                            </div>
                                        </div>
                                    </div>
                                    {goal.showMetrics && goal.metrics.length > 0 && this.renderRightMetricTable(m)}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        );
    }

    showMetrics (e, goal) {
        const setShowMetrics = (g, goal) => {
            if (g.parentRefId == goal.parentRefId) {
                g.showMetrics = typeof g.showMetrics === 'undefined'
                ? true
                : !g.showMetrics;
            }
            return g;
        };
        e.preventDefault();
        $(e.target)
            .closest('.okr-align-column-goal')
            .find('span')
            .trigger('mouseleave');
        this.clickCount++;
        if (this.clickCount == 1) {
            this.clickTimer = setTimeout(() => {
                this.clickCount = 0;
                if (goal.metricsCount) {
                    if (!goal.metrics || !goal.metrics.length) {
                        showLoaderWidget($("#content"));
                        this.GoalServices.getAlignGoalMetrics({goalId: goal.id})
                        .then(res => {
                          let goals = this.state.goals.map((g) => {
                            if (g.id == goal.id) {
                              g.metrics = res.data.goalMetrics;
                            }
                            return setShowMetrics(g, goal);
                          });
                          removeLoaderWidget(true);
                          this.setState({ goals }, () => {
                            this.setContainerHeight();
                          });
                        })
                    } else {
                        let goals = this.state.goals.map((g) => {
                          return setShowMetrics(g, goal);
                        });
                        this.setState({ goals }, () => {
                          this.setContainerHeight();
                        });
                    }
                }
            }, 300);
        } else {
            clearInterval(this.clickTimer);
            this.clickCount = 0;
            viewGoalDetailsPage(undefined, { id: goal.id });
        }
    }

    renderRightMetricTable (m) {
        const ownerTitle = this.state.showRealOwner
            ? (m.source == 5 || m.sourceText !== m.showRealOwner
                ? `Data from ${m.sourceText}` : '') : m.sourceText;
        const { source, type, ext_app_id: extAppId } = m;
        const isOwnerDataSource = m.sourceText === m.real_owner_fullname;
        const { icon } = getDataSourceInfo({ source, type, extAppId }, isOwnerDataSource);

        return (
            <div role="gridcell">
                <div
                    className="sourceTextDiv"
                    data-coltype={icon ? 'align-col-owner' : null}
                    tabIndex={icon ? -1 : null}
                    title={icon ? ownerTitle : null}
                    role={icon ? 'tooltip' : null}
                >
                    <span className="metric-source-from truncateText">
                        {m.showRealOwner}
                    </span>
                    {
                        this.state.showRealOwner
                        && <KrDataSourceIcon
                            kr={m}
                            isOwnerTheDataSource={isOwnerDataSource}
                            className="author-icon"
                        />
                    }
                </div>
            </div>
        );
    }

    closeAlignmentSlider = () => {
        // wb_track('close_one_level_alignment', { email: 'no data' }); cmt
        this.setState({
            showSlideshow: false,
        });
        $('body').css({ overflow: 'visible' });
    }

    prevArrowClick = () => {
        // wb_track('shift_previous_one_level_alignment', { email: 'no data' }); cmt
        let newDataIndex = this.state.currentSlideDataIndex - 1;
        if (newDataIndex < 0) {
            newDataIndex = this.state.originalData.length - 1;
        }
        this.setState({
            currentSlideDataIndex: newDataIndex,
        });
    }

    nextArrowClick = () => {
        // wb_track('shift_next_one_level_alignment', { email: 'no data' }); cmt
        let newDataIndex = this.state.currentSlideDataIndex + 1;
        if (newDataIndex > this.state.originalData.length - 1) {
            newDataIndex = 0;
        }
        this.setState({
            currentSlideDataIndex: newDataIndex,
        });
    }

    // Memoized so unrelated re-renders don't re-walk the whole alignment tree;
    // recomputes only when the source goals, filter criteria, or pinned goal change.
    getFilteredRootGoals = (rootLevelGoals) => {
        const { goals, filterCriteria } = this.state;
        const { goalId } = this.props;
        const memo = this.filterTreeMemo;
        if (memo.goals === goals && memo.criteria === filterCriteria && memo.goalId === goalId) {
            return memo.result;
        }
        const result = filterAlignmentTree(rootLevelGoals, filterCriteria, goalId);
        this.filterTreeMemo = { goals, criteria: filterCriteria, goalId, result };
        return result;
    }

    showTableContent = () => {
        const { t } = this.props;
        const goals = this.state.goals.filter(g => g.showTable);
        if (!goals.length) return <ErrorDisplay />;
        const maxLevel = this.getMaxExpandLevel(goals);
        const leftContent = [];
        const indentGoals = this.state.indentGoals || [];
        const rootGoals = this.getFilteredRootGoals(goals.filter(g => g.parentRow === 0));
        const goalsParentLength = rootGoals.length;
        rootGoals.forEach((g, index) => {
            const rowIndex = !!(index === 0);
            const r = this.renderLeftTable(g, maxLevel, indentGoals, rowIndex, goalsParentLength, index + 1);
            leftContent.push(r);
        });
        return (
            <>
                <div className="width100 okr-aligns-filters-toolbar" style={{ boxSizing: 'border-box', padding: '8px 34px 0px 0' }}>
                    <AlignmentModalFilters
                        appliedCount={this.state.appliedFilterCount}
                        initialValues={this.state.filterInitialValues}
                        teamOptions={this.state.teamOptions}
                        onApply={this.handleFiltersApply}
                        onReset={this.handleFiltersReset}
                    />
                    <div className="clear" />
                </div>
                {
                    this.props.showTitle
                        ? <div className="width100">
                            <div className="right" style={{ transform: 'translateX(40px)' }}>
                                <DropdownComp
                                    hideSelectedOption
                                    defaultValue={this.state.filterValue}
                                    options={this.getFilterOptions()}
                                    onChange={this.onChangeFilters}
                                    style
                                    appendId="okr-align"
                                />
                            </div>
                            <div className="clear" />
                          </div>
                        : ''
                }
                <div className={`width100 fullalignment-report-wrapper left ${this.props.wrapperClass}`}  style={{ overflowX: 'auto'}}>
                    {
                        this.state.originalData && this.state.showSlideshow
                            ? (
                                <div style={{ minHeight: '0px', minWidth: '0px' }}>
                                    <AlignmentSlider
                                        slideData={this.state.originalData}
                                        currentSlideDataIndex={this.state.currentSlideDataIndex}
                                        closeSlider={this.closeAlignmentSlider.bind(this)}
                                        prevArrowClick={this.prevArrowClick}
                                        nextArrowClick={this.nextArrowClick}
                                    />
                                </div>
                            ) : ''
                    }
                    {
                        this.props.showTitle
                            ? (
                                <div style={{ padding: '20px 20px 0px 10px' }}>
                                    {/* {...this.props.heading} />   */}
                                </div>
                            )
                            : ''
                    }
                    <div className="clear" />
                    {
                        this.state.originalData
                            ? <>
                                <div className="width100 okralignment-table">
                                    <div>
                                        <div
                                            role="treegrid"
                                            aria-label="The aligns chart below is a tree grid, please use focus/tab mode and arrow keys to navigate each level and cells."
                                            id="objective-dialog-alignment"
                                        >
                                            <div role="rowgroup">
                                                <div role="row" className="screen-reader-only">
                                                    <span role="columnheader">t{('Objective Metric')}</span>
                                                    <span role="columnheader">{t('Objective Name')}</span>
                                                    <span role="columnheader">{t('Team')}</span>
                                                    <span role="columnheader">{t('End Date')}</span>
                                                    <span role="columnheader">{t('Action')}</span>
                                                </div>
                                            </div>
                                            <div role="rowgroup">
                                                {this.props.showHeader && this.leftContentHeader()}
                                                {leftContent}
                                            </div>
                                        </div>
                                        <div style={{ height: '10px' }} />
                                    </div>
                                    <div className="clear" />
                                </div>
                            </>
                            : <ErrorDisplay />
                    }
                    <div className="clear" />
                </div>
            </>
        );
    }

    render () {
        return this.showTableContent();
    }
}
export default withTranslation()(OkrAlignment);
